import { createRouter } from "@tanstack/react-router";

import { routeTree } from "./routeTree.gen.ts";
import { clearHandedPhotos } from "./shell/photo-handoff.ts";
import { PendingPage } from "./shell/skeletons.tsx";

import type { DataLayer } from "./data/data-layer.tsx";
import type { Router } from "@tanstack/react-router";

export interface RouterContext {
  readonly data: DataLayer;
}

export type AppRouter = Router<typeof routeTree>;

export const createAppRouter = (data: DataLayer): AppRouter => {
  const router = createRouter({
    routeTree,
    context: { data },
    defaultPreload: "intent",
    defaultPreloadStaleTime: 0,
    defaultPendingMinMs: 300,
    defaultPendingMs: 150,
    defaultPendingComponent: PendingPage,
    scrollRestoration: true,
  });
  // WHY: a session revoked elsewhere signs out during the first load, before any route component mounts to listen.
  data.auth.onSignedOut((reason) => {
    clearHandedPhotos();
    void router.navigate({ to: "/sign-in", search: reason === "security" ? { reason } : {} });
  });
  return router;
};

declare module "@tanstack/react-router" {
  interface Register {
    router: AppRouter;
  }
  // WHY: history state, unlike the URL, cannot come from a pasted link; only the search answer's Reveal sets this.
  interface HistoryState {
    readonly revealOnArrival?: boolean;
  }
  interface StaticDataRouteOption {
    readonly title?: (parameters: Readonly<Record<string, string | undefined>>) => string;
    readonly hasPropertyContext?: boolean;
    readonly hasHero?: boolean;
  }
}
